import { useEffect } from "react";
import Header from "../components/user/Header";
import HeroCarousel from "../components/user/homepage_components/HeroCarousel";
import FeaturedCategories from "../components/user/homepage_components/FeaturedCategories";
import PopularItems from "../components/user/homepage_components/PopularItems";
import RentalProcess from "../components/user/homepage_components/RentalProcess";
import Gallery from "../components/user/homepage_components/Gallery";
import TrustSignals from "../components/user/homepage_components/TrustSignals";
import Insights from "../components/user/homepage_components/Insights";
import Footer from "../components/user/Footer";
import FloatingActions from "../components/user/FloatingActions";

import useHomepageData from "../hooks/user/useHomepageData";

export default function HomePage() {
  const {
    categories,
    popularItems,
    gallery,
    insights,
    loading,
  } = useHomepageData();

  useEffect(() => {
      window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white dark:bg-[#121212]">
      <Header />
      <HeroCarousel />
      <FeaturedCategories 
        categories={categories}
        isLoading={loading}
      />

      <PopularItems
        items={popularItems}
        isLoading={loading}
      />
      <RentalProcess />
      <Gallery 
        images={gallery}
        isLoading={loading}
      />

      <TrustSignals />
      <Insights 
        articles={insights}
        isLoading={loading}
      />
      <Footer />
      <FloatingActions />
    </div>
  );
}